import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_CONFS: 'Carregando conferencias',
  GET_PRODUTOS: 'Carregando posições',
  SAVE_CONF: 'Salvando conferencia',
}

const INITIAL_STATE = {
  produtos: [],
  conferencias: [],
  selectedConferencia: null,
  pathToRedirect: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalPosicoesAssociadas() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      getConferenciasFromPosicao(selectedTp, inventarioId, posicaoId) {
        EstoqueHttp.getConferenciasFromPosicao(selectedTp, inventarioId, posicaoId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              conferencias: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutosFromConferencia(selectedTp, conferenciaId) {
        EstoqueHttp.getProdutosFromConferenciaPosicaoOnInventario(selectedTp, conferenciaId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              produtos: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      saveProdutosConferenciaManual(selectedTp, selectedConferenciaId, produtos) {
        EstoqueHttp.saveProdutosFromConferenciaPosicaoOnInventario(
          selectedTp,
          selectedConferenciaId,
          produtos,
        )
          .then(res => {
            setState(prevState => ({
              ...prevState,
              produtos: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Actions
      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.GET_CONFS,
          }))
        } else {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        }
      },

      onChangeProduto(name, value, produto) {
        setState(prevState => {
          const prodIndex = prevState.produtos.findIndex(p => p.id === produto.id)
          if (prodIndex !== -1) {
            prevState.produtos[prodIndex][name] = value
          }
          return { ...prevState }
        })
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          if (name === 'selectedConferencia') {
            prevState.loadingMessage = LOAD_MESSAGE.GET_PRODUTOS
          }
          return { ...prevState }
        })
      },

      onClickSalvarContagem(produtos) {
        if (!produtos.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Não existem produtos para serem atualizados',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_CONF }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      resetModal() {
        setState({ ...INITIAL_STATE })
      },
    }
  }, [])

  return { state, localDispatch }
}
